import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { id: "news" };
const _hoisted_2 = {
    key: 0,
    id: "banner"
};
const _hoisted_3 = { class: "info" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { id: "news-list" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "NEWS")
], -1 /* HOISTED */);
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "list" };
const _hoisted_11 = { class: "header" };
const _hoisted_12 = {
    key: 0,
    class: "loading"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/loading.gif",
    alt: "Loading"
}, null, -1 /* HOISTED */);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = {
    key: 1,
    class: "not-found"
};
const _hoisted_16 = ["src", "alt"];
const _hoisted_17 = { class: "info" };
const _hoisted_18 = { class: "title" };
const _hoisted_19 = { class: "date" };
const _hoisted_20 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        (_ctx.mainNews)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.mainNews.title), 1 /* TEXT */),
                    (_ctx.mainNews.description)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            innerHTML: _ctx.mainNews.description
                        }, null, 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                ]),
                (_ctx.mainNews.thumbnail)
                    ? (_openBlock(), _createElementBlock("figure", _hoisted_5, [
                        _createElementVNode("img", {
                            src: `/images/news/${_ctx.mainNews.thumbnail}`,
                            alt: _ctx.mainNews.title
                        }, null, 8 /* PROPS */, _hoisted_6)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("section", _hoisted_7, [
            _hoisted_8,
            _createCommentVNode(" TODO: Remove on production "),
            false
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eaque quis reiciendis illo veniam nesciunt quidem dignissimos alias, et maiores voluptatem corporis eos quia reprehenderit aspernatur, error vero porro similique ipsam. "))
                : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.prevMonth()), ["prevent"]))
                    }, "<"),
                    _createTextVNode(" " + _toDisplayString(`${_ctx.currentTxtMonth} ${_ctx.currentYear}`) + " ", 1 /* TEXT */),
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.nextMonth()), ["prevent"]))
                    }, ">")
                ]),
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                    : (!_ctx.loading && !_ctx.news.count)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No news currently for this month. "))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.news.items, (item, index) => {
                            return (_openBlock(), _createElementBlock("article", {
                                class: "item",
                                key: index
                            }, [
                                _createElementVNode("figure", null, [
                                    _createElementVNode("img", {
                                        src: `/images/news/${item.thumbnail}`,
                                        alt: item.title
                                    }, null, 8 /* PROPS */, _hoisted_16)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(item.date), 1 /* TEXT */),
                                    _createElementVNode("div", {
                                        class: "description",
                                        innerHTML: item.description
                                    }, null, 8 /* PROPS */, _hoisted_20)
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
            ])
        ])
    ]));
}
